import { render, staticRenderFns } from "./CardCommonProduct.vue?vue&type=template&id=779c2155"
import script from "./CardCommonProduct.vue?vue&type=script&lang=js"
export * from "./CardCommonProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports